import './questionnaire-progress-bar.scss';
import propTypes from 'prop-types';

export default function QuestionnaireProgressBar({
  categories,
  currentCategoryIndex
}) {
  return (
    <div className="questionnaire-progress-bar">
      {categories.map((category, index) => {
        return index === currentCategoryIndex ? (
          <span key={index} className="dot current">
            <span className="category-name">{category}</span>
          </span>
        ) : (
          <span
            key={index}
            className={`dot ${
              index < currentCategoryIndex ? 'completed' : ''
            } `}
          />
        );
      })}
    </div>
  );
}

QuestionnaireProgressBar.propTypes = {
  categories: propTypes.array,
  currentCategoryIndex: propTypes.number
};
